import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type ReactElement, memo } from 'react';

import styles from './PrizeCard.css';

interface PrizeCardProps {
    title: string;
    description?: string | ReactElement;
    size?: 'small' | 'medium' | 'large';
    isBlue?: boolean;
    isMobile?: boolean;
    label?: string;
}

export const PrizeCard = memo(({ title, description, size = 'medium', isBlue, isMobile, label }: PrizeCardProps) => {
    return (
        <div
            className={classNames(styles.root, {
                [styles[`root_size_${size}`]]: size,
                [styles.root_blue]: isBlue,
                [styles.root_mobile]: isMobile,
            })}
        >
            <div className={styles.title}>{title}</div>
            {Boolean(description) && (
                <>
                    <Spacing size={4} />
                    <div className={styles.description}>{description}</div>
                </>
            )}
            <div className={styles.label}>{label || 'Сертификат'}</div>
        </div>
    );
});

PrizeCard.displayName = 'PrizeCard';
